import React, { useContext, useEffect } from "react";
import { Github, Facebook, Twitter, Linkedin, Youtube } from "lucide-react";
import "./Home.css";
import { Outlet, useNavigate } from "react-router-dom";
import logo from "../images/iiit_logo.png";
import homeBg from "../images/home_bg.jpg"; // Placeholder for the provided image
import { LoginContext } from "../context/LoginContext";

const Home = () => {
  const navigate = useNavigate();
  const { user } = useContext(LoginContext);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const storedUser = localStorage.getItem("user");

    if (isLoggedIn && storedUser && user) {
      try {
        const user = JSON.parse(storedUser);
        if (user.role.toLowerCase() === "admin") {
          navigate("/dashboard", { replace: true });
        } else if (user.role.toLowerCase() === "student") {
          navigate("/applicant/home", { replace: true });
        }
      } catch (e) {
        console.error("Failed to parse user from localStorage", e);
      }
    }
  }, [navigate]);
  return (
    <div className="login-container" style={{ backgroundImage: `url(${homeBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <div className="login-content">
        {/* LEFT SIDE – BRANDING */}
        <div className="branding-section" style={{ background: 'transparent' }}>

          <div className="branding-content">
            {/* Logo */}
            <div className="logo-container" style={{ marginBottom: "20px" }}>
              <img
                src={logo}
                alt="logo"
                className="logo"
                style={{
                  width: "100px",
                  height: "100px",
                  filter: "brightness(0) invert(1)",
                }}
              />
            </div>

            {/* Institute Name */}
            <div className="institution-info" style={{ marginBottom: "10px" }}>
              <h1
                className="institution-name"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  lineHeight: "1.3",
                  textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                International Institute of
              </h1>
              <h1
                className="institution-name"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  lineHeight: "1.3",
                  textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                Information Technology Bangalore
              </h1>
            </div>

            {/* Portal Title */}
            <div className="portal-title">
              <h2 style={{ fontSize: "32px", fontWeight: "700" }}>
                Admissions Portal
                <span
                  style={{
                    display: "block",
                    fontSize: "20px",
                    fontWeight: "500",
                    marginTop: "5px",
                  }}
                >
                  B.Tech/Integrated-M.Tech/M.Tech
                </span>
              </h2>
              <div
                style={{
                  marginTop: "22px",     // gap from title above
                  marginBottom: "16px", // gap below
                  fontSize: "16px",
                  fontWeight: "550",
                  lineHeight: "1.4",
                }}
              >
                The last date for submitting the online application (B.Tech & Integrated M.Tech) has been extended to <br></br> <strong>June 10, 2026</strong>.
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="branding-footer">
            {/* Social Icons */}
            <div
              className="social-icons"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "20px",
              }}
            >
              <a
                href="https://www.facebook.com/IIITBofficial"
                className="social-icon"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  textDecoration: "none",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  transition: "all 0.3s ease",
                }}
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://x.com/IIITB_official"
                className="social-icon"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  textDecoration: "none",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  transition: "all 0.3s ease",
                }}
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://www.linkedin.com/school/iiitbofficial"
                className="social-icon"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  textDecoration: "none",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  transition: "all 0.3s ease",
                }}
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.youtube.com/user/iiitbmedia"
                className="social-icon"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  textDecoration: "none",
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  transition: "all 0.3s ease",
                }}
              >
                <Youtube size={20} />
              </a>
            </div>

            {/* Copyright */}
            <div className="copyright">
              <p
                style={{
                  fontSize: "12px",
                  opacity: "0.8",
                  marginBottom: "5px",
                }}
              >
                © 2026 International Institute of Information Technology -
                Bangalore
              </p>
              <p className="support-text">
                Support - admissions2026@iiitb.ac.in | +91 80 4140 7777 (9:00 AM – 5:00 PM)
              </p>

            </div>
            <div className="text-center mt-3">
              <p style={{
                fontSize: "14px",
                opacity: "0.8",
                marginBottom: "5px",
              }} className="support-text">
                <a href="https://iiitbac-my.sharepoint.com/:w:/g/personal/vivek_yadav_iiitb_ac_in/IQC1oTWdadHAQKaxtlei0iq_Acm4F8iXpXrKSJ4gSF02-cg?e=amMU4I" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'underline', fontWeight: '700' }}>
                  Terms & Conditions | Refund & Cancellation Policy
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE – FORM SECTION */}
        <div className="form-section">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Home;
